import { render } from "./StoreFeedPanel.vue?vue&type=template&id=23c3beca&scoped=true&lang=pug"
import script from "./StoreFeedPanel.vue?vue&type=script&lang=js"
export * from "./StoreFeedPanel.vue?vue&type=script&lang=js"

import "./StoreFeedPanel.vue?vue&type=style&index=0&id=23c3beca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c3beca"]])

export default __exports__